/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespRefineMenuSelector_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenu_user">;
    readonly " $refType": "SbRespRefineMenuSelector_user";
};
export type SbRespRefineMenuSelector_user$data = SbRespRefineMenuSelector_user;
export type SbRespRefineMenuSelector_user$key = {
    readonly " $data"?: SbRespRefineMenuSelector_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuSelector_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenu_user",
      "args": null
    }
  ]
};
(node as any).hash = 'ee7af77e836745da5513d2f7f4f23534';
export default node;
